"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataModelToJSON = exports.MetadataModelFromJSONTyped = exports.MetadataModelFromJSON = void 0;
const runtime_1 = require("../runtime");
function MetadataModelFromJSON(json) {
    return MetadataModelFromJSONTyped(json, false);
}
exports.MetadataModelFromJSON = MetadataModelFromJSON;
function MetadataModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hasFingerprintsOnFile': !runtime_1.exists(json, 'hasFingerprintsOnFile') ? undefined : json['hasFingerprintsOnFile'],
    };
}
exports.MetadataModelFromJSONTyped = MetadataModelFromJSONTyped;
function MetadataModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hasFingerprintsOnFile': value.hasFingerprintsOnFile,
    };
}
exports.MetadataModelToJSON = MetadataModelToJSON;
//# sourceMappingURL=MetadataModel.js.map